import React from "react"
import styled from "styled-components"
import { CURSOR_TYPES } from "@repo/utils/constants"
import Button from "./Button"
import { useSelector } from "react-redux"
import Image from "./Image"

const LinkButton = ({ external = false, className, isDisabled, ...props }) => {
	const tag = external && !isDisabled ? "a" : !external && !isDisabled ? "link" : "div"
	return (
		<Button
			id="top-row-story-button"
			as={tag}
			className={`${className} ${isDisabled ? "disabled" : ""}`}
			data-cursor={CURSOR_TYPES.HIDE}
			{...props}
		>
			<Image src={"/images/pleo_story_sphere.png"} />
		</Button>
	)
}

const StyledButton = styled(LinkButton)`
	aspect-ratio: 1;
	display: flex;
	align-self: center;
	overflow: hidden !important;
	border-radius: 50%;

	.image {
		--size: calc(35px / 1.5);
		width: var(--size);
		height: var(--size);
		aspect-ratio: 1;
	}

	//translate: 0 25%;
	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		.image {
			--size: calc(43px / 1.5);
		}
	}

	opacity: 0;
	visibility: hidden;
	pointer-events: none;
	transition: opacity var(--color-transition-duration) var(--ease);

	&.visible {
		opacity: 1;
		visibility: visible;
		pointer-events: auto;
	}
	&.disabled {
		* {
			cursor: default !important;
		}
	}
`
const StoryButton = ({ variant = "unstyled", href = "/story", external = false, className = "", isDisabled, ...props }) => {
	const { open } = useSelector((state) => state.menu)

	return (
		<StyledButton
			variant={variant}
			href={href}
			external={external}
			className={`${className} story-button ${!open ? "visible" : ""}`}
			isDisabled={isDisabled}
			{...props}
		/>
	)
}

export default StoryButton
